import * as z from 'zod';
import { StoreRegion } from '~/graphql/graphql.gen';

export const aitoolsQueryParamsSchema = z.object({
  region: z.enum([StoreRegion.Fr, StoreRegion.Us]).catch(StoreRegion.Fr),
});

export type AitoolsQueryParams = z.infer<typeof aitoolsQueryParamsSchema>;
